"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeHeaderCell = void 0;
const react_1 = __importDefault(require("react"));
const generic_1 = require("../../generic");
const localization_1 = require("../../../localization");
const AttributeHeaderCell = ({ attributeName, onManageAttribute, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const handleGuidelineButtonClick = (e) => {
        e.stopPropagation();
        onManageAttribute(attributeName);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(generic_1.GuidelineButton, { color: "secondary", tooltipText: t({ key: 'MANAGE_ATTRIBUTE' }), onClick: handleGuidelineButtonClick }), attributeName));
};
exports.AttributeHeaderCell = AttributeHeaderCell;
exports.default = exports.AttributeHeaderCell;
